import { Grid } from "@mui/material";
import React from "react";
import Controls from "../../../components/FormsUI";
export default function ImagePreview({ image, popup, handlePopup, field }) {
  return (
    <>
      {popup && (
        <Controls.Popup
          minHeight={500}
          title="Image preview"
          openPopup={popup}
          setOpenPopup={() => handlePopup(field, false)}
        >
          <>
            <Grid item xs={12} className="formBg popup">
              <img src={image} height={420} width={500} alt="Logo" style={{marginLeft: '5.5em'}}/>
            </Grid>
          </>
        </Controls.Popup>
      )}
    </>
  );
}
